// extracted by mini-css-extract-plugin
export var image = "_ic-0";